import { createFcmDetails } from '../shared/factory';

export const FCM_DETAILS_AI_SHARE_HEADLINE_BANDIT = createFcmDetails('ai_share_headline_bandit', {
	owner: 'Starfish',
	context: 'petition shares',
	description: 'Controls the prompt used for generating share headline bandit options',
	import: false,
	template: {
		enabled: true,
		prompt:
			'A petition on change.org has a title {title} and a description {description}. Create three share headlines that will create the most engagement and signatures on social media. Format your answer as an array of strings.',
		model: 'gpt-4',
	},
});
